module.exports = __webpack_public_path__ + "img/banner-4.ac056fa4.png";